import { render, staticRenderFns } from "./paperExerciseCreate.vue?vue&type=template&id=70348ea1&scoped=true&"
import script from "./paperExerciseCreate.js?vue&type=script&lang=js&"
export * from "./paperExerciseCreate.js?vue&type=script&lang=js&"
import style0 from "./paperExerciseCreate.vue?vue&type=style&index=0&lang=sass&rel=stylesheet%2Fsass&"
import style1 from "./paperExerciseCreate.sass?vue&type=style&index=1&id=70348ea1&lang=sass&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70348ea1",
  null
  
)

export default component.exports